import { colors } from '@atlaskit/theme';
import styled from 'styled-components';

export const TextSkeleton = styled.div<{ width: string }>`
  background-color: ${colors.N20};
  display: inline-block;
  height: 16px;
  margin: 1px;
  border-radius: 3px;
  width: ${({ width }) => width};
`;
